import React, { memo } from 'react'

import { REWARDS_PROFILE_DISPATCH } from '../../store/reducers/rewards/rewards'
import customConfig from 'customConfig'
import { FormHead } from '../shared/auth/form-head'
import CustomTextField from '../shared/inputs/CustomTextField'

const ReceiveReward = ({
  dispatchAction,
  rewardsProfile: { error, rewardCode },
  onQrCodeClick,
  t,
  qrCodeEnabled,
  noHeader
}) => {
  return (
    <>
      {!noHeader && (
        <FormHead
          title={t(customConfig.enterYourRewardCodeLabel)}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
        />
      )}
      <CustomTextField
        qrCodeEnabled={qrCodeEnabled}
        onQrCodeClick={onQrCodeClick}
        label={t(customConfig.enterRewardCodeLabel)}
        alignCenter
        error={t(error[REWARDS_PROFILE_DISPATCH.REWARD_CODE])}
        value={rewardCode}
        onChange={(value) =>
          dispatchAction(REWARDS_PROFILE_DISPATCH.REWARD_CODE, value)
        }
      />
    </>
  )
}

export default memo(ReceiveReward)
